import React from "react"
import ReactMarkdown from "react-markdown"

interface ISlackMarkdown {
  children: string
  inline?: boolean
}

const convertSlackToMarkdown = (text: string) => {
  // Convert Slack links: <URL|Text> -> [Text](URL)
  let converted = text.replace(/<(https?:\/\/[^|>]+)\|([^>]+)>/g, "[$2]($1)")
  // Convert plain Slack links: <URL> -> [URL](URL)
  converted = converted.replace(/<(https?:\/\/[^>]+)>/g, "[$1]($1)")
  // Convert Slack bold: *text* -> **text** (only if not already markdown)
  converted = converted.replace(/(?<!\*)\*(?!\*)([^*\n]+)\*(?!\*)/g, "**$1**")
  return converted
}

const SlackMarkdown = ({ children, inline = false }: ISlackMarkdown) => {
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) =>
          inline ? (
            <span>{children}</span>
          ) : (
            <p style={{ margin: "0 0 8px 0" }}>{children}</p>
          ),
        a: ({ children, href }) => (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff" }}
            onClick={(e) => (inline ? e.stopPropagation() : undefined)}
          >
            {children}
          </a>
        ),
        strong: ({ children }) => (
          <strong style={{ fontWeight: 600 }}>{children}</strong>
        ),
        code: ({ children, className }) => {
          const isInline = !className
          return isInline ? (
            <code
              style={{
                backgroundColor: "#f8f9fa",
                padding: "2px 4px",
                borderRadius: "4px",
                fontSize: "13px",
                fontFamily: "monospace",
              }}
            >
              {children}
            </code>
          ) : (
            <code
              style={{
                display: "block",
                backgroundColor: "#f8f9fa",
                padding: "12px",
                borderRadius: "8px",
                fontSize: "13px",
                fontFamily: "monospace",
                overflowX: "auto",
              }}
            >
              {children}
            </code>
          )
        },
      }}
    >
      {convertSlackToMarkdown(children)}
    </ReactMarkdown>
  )
}

export default SlackMarkdown
